import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=0a8918a9&scoped=true&"
import script from "./FooterBar.vue?vue&type=script&lang=js&"
export * from "./FooterBar.vue?vue&type=script&lang=js&"
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=0a8918a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8918a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a8918a9')) {
      api.createRecord('0a8918a9', component.options)
    } else {
      api.reload('0a8918a9', component.options)
    }
    module.hot.accept("./FooterBar.vue?vue&type=template&id=0a8918a9&scoped=true&", function () {
      api.rerender('0a8918a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layouts/FooterBar.vue"
export default component.exports